module.exports = __webpack_public_path__ + "static/media/ecopotager-mockup.7592d200.png";